import React from "react";
import {Route} from "react-router-dom";
import {
    EDIT_PARAMETERS_ROUTE,
    EDIT_INSTITUTION_ROUTE,
    UPDATE_ADDRESS_ROUTE
} from "../../utils/constants/RoutesConstants";
import EditParametersContainer from "../../pages/admin/invoice/editParameters/EditParametersContainer";
import EditInstitution from "../../pages/admin/invoice/editInstitution";
import UpdateAddress from "../../pages/admin/invoice/editAddressInstitution";

const InvoiceRoutes = () => {
    return (
        <React.Fragment>
            <Route path={EDIT_PARAMETERS_ROUTE} component={EditParametersContainer}/>
            <Route path={EDIT_INSTITUTION_ROUTE} component={EditInstitution}/>
            <Route path={UPDATE_ADDRESS_ROUTE} component={UpdateAddress}/>
        </React.Fragment>
    );
};

export default InvoiceRoutes;